import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import ProductCallout from '~/shared/components/ProductCallout';
import { useProductInventoryCallout } from '~/shared/utils/useProductCallout';
import { mobile } from '~/techstyle-shared/react-components';

import { shouldShowCalloutOverlay } from '../../hooks/useProductCalloutOverlay';

const ProductCardCalloutWrapper = styled.span`
  display: flex;
  height: 10px;
  padding-left: 16px; /* desktop */
  align-items: center;
  gap: 10px;
  align-self: stretch;
  ${mobile`
    padding-left: 12px;
  `}
`;

const CalloutText = styled(ProductCallout)`
  display: flex;
  height: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  color: ${({ theme }) => theme.colors.gr2ProductCardCallout};
  leading-trim: both;
  text-edge: cap;
  font-family: ${({ theme }) => theme.fontStacks.standardGtPressuraFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
  text-transform: uppercase;
`;

const ProductCardInfoIndicator = ({ product }) => {
  const callout = useProductInventoryCallout({
    product,
  });

  if (
    !product ||
    !callout ||
    !callout?.type ||
    shouldShowCalloutOverlay({ callout })
  ) {
    return null;
  }

  return (
    <ProductCardCalloutWrapper>
      <CalloutText type={callout.type} value={callout.value} />
    </ProductCardCalloutWrapper>
  );
};

ProductCardInfoIndicator.propTypes = {
  product: PropTypes.shape({
    dateExpected: PropTypes.string,
    tagIdList: PropTypes.arrayOf(PropTypes.number),
    membershipBrandId: PropTypes.number,
    waitListAllowed: PropTypes.bool,
    skus: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        isPreorder: PropTypes.bool,
      })
    ),
    availableQuantity: PropTypes.number,
    availableQuantityMaster: PropTypes.number,
    productIdObjectList: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        availableQuantityPreorder: PropTypes.number,
      })
    ),
  }),
};

export default ProductCardInfoIndicator;
